import { REQUEST_GET_JUDGEMENTS } from 'containers/common/LegalProceedings/constants';

export const requestGetJudgements = (
  claimId: string,
  procedureType: string,
  judiciaryProcessId: string,
) => {
  return {
    type: REQUEST_GET_JUDGEMENTS,
    claimId,
    procedureType,
    judiciaryProcessId,
  };
};
